export default "__VITE_ASSET__DotoL2bN__"